import SuccessBlock from './SuccessBlock';

export default SuccessBlock;
